import { HttpContextToken } from '@angular/common/http';

export const INCLUDE_ORGANIZATION_ID_HEADER = new HttpContextToken<boolean>(() => false);

/**
 * Background requests (polling) that must not extend the session-manager inactivity timeout
 */
export const SKIP_SESSION_REFRESH = new HttpContextToken<boolean>(() => false);
